import api from './api';

// Starts an on-demand debate of the expert panel on one instrument; resolves
// with the run id to follow on /reports/live?run=<id>.
export const startDebate = async ({ symbol, description = '', question = '' }) => {
  const res = await api.post('/analysis/expert-debates', { symbol, description, question });
  return res.data.run_id;
};

export const debateLivePath = (runId) => `/reports/live?run=${runId}`;
